import { CONTACT_INFO, LOGO_URL } from '../../data/content';

const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-amber-400/10 bg-[#040D1A] pt-16 pb-8">
    <div className="container mx-auto px-4">
      <div className="grid md:grid-cols-3 gap-10 items-start">
        <div className="flex items-center gap-3">
          <img
            src={LOGO_URL}
            alt="Logomarca Leão de Fogo"
            className="w-12 h-12 object-contain drop-shadow-[0_0_12px_rgba(252,211,77,0.3)]"
          />
          <div>
            <p className="font-chapaza italic font-bold uppercase text-lg text-white leading-none">
              Leão de Fogo
            </p>
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-amber-300/80 mt-1">
              Indústria · Comércio · Projetos
            </p>
          </div>
        </div>

        <nav className="flex flex-col gap-3 font-mono text-xs uppercase tracking-[0.22em]">
          <a href="/#produtos" className="text-slate-400 hover:text-amber-300 transition-colors w-fit">
            Produtos
          </a>
          <a href="/#servicos" className="text-slate-400 hover:text-amber-300 transition-colors w-fit">
            Serviços
          </a>
          <a href="/#sobre" className="text-slate-400 hover:text-amber-300 transition-colors w-fit">
            Sobre Nós
          </a>
          <a href="/#contato-form" className="text-slate-400 hover:text-amber-300 transition-colors w-fit">
            Contato
          </a>
        </nav>

        <div className="flex flex-col gap-2 text-sm text-slate-400 md:text-right">
          <a
            href={`https://wa.me/${CONTACT_INFO.whatsappNumber}`}
            target="_blank"
            rel="noreferrer"
            className="hover:text-amber-300 transition-colors"
          >
            {CONTACT_INFO.whatsappDisplay}
          </a>
          <a href={`mailto:${CONTACT_INFO.email}`} className="hover:text-amber-300 transition-colors">
            {CONTACT_INFO.email}
          </a>
        </div>
      </div>

      <div className="mt-12 pt-6 border-t border-white/5 text-center">
        <p className="text-xs text-slate-500 font-mono uppercase tracking-[0.2em]">
          © {new Date().getFullYear()} Leão de Fogo · Todos os direitos reservados
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
